import React from 'react'
import { BANKING_BOTTOM_CONTENT, DIGITAL_COURSE_PAGE_4, DIGITAL_DETAILS_PAGE_4, DIGITAL_HERO_PAGE_4 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { DIGITAL_ACCORDIAN_4 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const DigitalPage_4 = () => {
  return (
    <div className='outlet-render'>
                   <CourseAsideHero  {...DIGITAL_HERO_PAGE_4}/>
      <CoursesAside {...DIGITAL_COURSE_PAGE_4}/>
      <CourseCard {...DIGITAL_DETAILS_PAGE_4}/>
      <Accordian {...DIGITAL_ACCORDIAN_4}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default DigitalPage_4